/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Empty_TitleInputs */

const en_us2_body_assessment_empty_title = /** @type {(inputs: Body_Assessment_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No photo estimate yet`)
};

const pt_br2_body_assessment_empty_title = /** @type {(inputs: Body_Assessment_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda sem estimativa por foto`)
};

const es_419_body_assessment_empty_title = /** @type {(inputs: Body_Assessment_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay estimación por foto`)
};

const pt_pt2_body_assessment_empty_title = /** @type {(inputs: Body_Assessment_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda sem estimativa por foto`)
};

const fr_fr2_body_assessment_empty_title = /** @type {(inputs: Body_Assessment_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas encore d'estimation par photo`)
};

const de_de2_body_assessment_empty_title = /** @type {(inputs: Body_Assessment_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Fotoschätzung`)
};

const it_it2_body_assessment_empty_title = /** @type {(inputs: Body_Assessment_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessuna stima da foto`)
};

/**
* | output |
* | --- |
* | "No photo estimate yet" |
*
* @param {Body_Assessment_Empty_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_empty_title = /** @type {((inputs?: Body_Assessment_Empty_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Empty_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_empty_title(inputs)
	if (locale === "es-419") return es_419_body_assessment_empty_title(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_empty_title(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_empty_title(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_empty_title(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_empty_title(inputs)
	return en_us2_body_assessment_empty_title(inputs)
});
export { body_assessment_empty_title as "body-assessment.empty_title" }